import imgMas30 from '../../../assets/img/alertas/ic-+30.svg';
import imgJammer from '../../../assets/img/alertas/ic-Jammer.svg';
import imgAceleracionBrusca from '../../../assets/img/alertas/ic-aceleración-brusca.svg';
import imgAddon from '../../../assets/img/alertas/ic-addon-añadido.svg';
import imgAlcoholimetroNoSuperaro from '../../../assets/img/alertas/ic-alcoholimetro-no-superado.svg';
import imgAproximacion from '../../../assets/img/alertas/ic-alerta-aproximación.svg';
import imgAproximacion1 from '../../../assets/img/alertas/ic-alerta-aproximación_1.svg';
import imgConexionTomaFuerza from '../../../assets/img/alertas/ic-alerta-de-conexion-de-toma-de-fuerza.svg';
import imgDesconexionTomaFuerza from '../../../assets/img/alertas/ic-alerta-de-desconexion-de-toma-de-fuerza.svg';
import imgApagadoMotorActivado from '../../../assets/img/alertas/ic-apagado-motor-activado.svg';
import imgApagadoMotorDesactivado from '../../../assets/img/alertas/ic-apagado-motor-desactivado.svg';
import imgBateriaBaja from '../../../assets/img/alertas/ic-bateria-baja.svg';
import imgBloqueoPuerta from '../../../assets/img/alertas/ic-bloqueo-de-puerta.svg';
import imgBotonPanico from '../../../assets/img/alertas/ic-botón-pánico.svg';
import imgCheckEngine from '../../../assets/img/alertas/ic-check-engine.svg';
import imgColicionDerecha from '../../../assets/img/alertas/ic-colición-derecha.svg';
import imgColicionIzquierda from '../../../assets/img/alertas/ic-colición-izquierda.svg';
import imgColicionFrontera from '../../../assets/img/alertas/ic-colición-frontera.svg';
import imgColicionTrasera from '../../../assets/img/alertas/ic-colición-trasera.svg';
import imgDesbloqueoPuerta from '../../../assets/img/alertas/ic-desbloqueo-de-puerta.svg';
import imgDetenido from '../../../assets/img/alertas/ic-detenido.svg';
import imgDvrDesconectado from '../../../assets/img/alertas/ic-dvr-desconectado.svg';
import imgEncendidoSinPruebaAlcohol from '../../../assets/img/alertas/ic-encendido-sin-prueba-de-alcohol.svg';
import imgEntroCliente from '../../../assets/img/alertas/ic-entro-cliente.svg';
import imgEntroGeocerca from '../../../assets/img/alertas/ic-entro-geocerca.svg';
import imgEstacionCargaDentro from '../../../assets/img/alertas/ic-estacion-carga-dentro.svg';
import imgEstacionCargaFuera from '../../../assets/img/alertas/ic-estacion-carga-fuera.svg';
import imgExcesoVelocidad from '../../../assets/img/alertas/ic-exceso-velocidad.svg';
import imgFallaCorriente from '../../../assets/img/alertas/ic-falla-corriente.svg';
import imgFrenadoBrusco from '../../../assets/img/alertas/ic-frenado-brusco.svg';
import imgFuerzaOff from '../../../assets/img/alertas/ic-fuerza-off.svg';
import imgFuerzaOn from '../../../assets/img/alertas/ic-fuerza-on.svg';
import imgIcon1 from '../../../assets/img/alertas/ic-icon1.svg';
import imgIcon2 from '../../../assets/img/alertas/ic-icon2.svg';
import imgIcon3 from '../../../assets/img/alertas/ic-icon3.svg';
import imgMotorOff from '../../../assets/img/alertas/ic-motor-off.svg';
import imgMotorOn from '../../../assets/img/alertas/ic-motor-on.svg';
import imgOleajeCombustible from '../../../assets/img/alertas/ic-oleaje-de-combustible.svg';
import imgPerdidaSenial from '../../../assets/img/alertas/ic-perdida-señal.svg';
import imgPuertaAbierta from '../../../assets/img/alertas/ic-puerta-abierta.svg';
import imgPuertaCerrada from '../../../assets/img/alertas/ic-puerta-cerrada.svg';
import imgPuntoApagado from '../../../assets/img/alertas/ic-punto-en-apagado.svg';
import imgPuntoGps from '../../../assets/img/alertas/ic-punto-en-gps.svg';
import imgPuntoFinal from '../../../assets/img/alertas/ic-punto-final.svg';
import imgPuntoInicial from '../../../assets/img/alertas/ic-punto-inicial.svg';
import imgRangoHumedad from '../../../assets/img/alertas/ic-rango-humedad.svg';
import imgReferencia from '../../../assets/img/alertas/ic-referencia.svg';
import imgRoboCombustible from '../../../assets/img/alertas/ic-robo-combustible.svg';
import imgRpm from '../../../assets/img/alertas/ic-rpm.svg';
import imgSalioCliente from '../../../assets/img/alertas/ic-salio-cliente.svg';
import imgSalioGeocerca from '../../../assets/img/alertas/ic-salio-geocerca.svg';
import imgSeguroMagnetico from '../../../assets/img/alertas/ic-seguro-magnetico.svg';
import imgSensorCombustibleContaminado from '../../../assets/img/alertas/ic-sensor-de-combustible-contaminado.svg';
import imgSensorCombustibleDesconectado from '../../../assets/img/alertas/ic-sensor-de-combustible-desconectado.svg';
import imgSensorCombustibleReconectado from '../../../assets/img/alertas/ic-sensor-de-combustible-reconectado.svg';
import imgTemperaturaMotor from '../../../assets/img/alertas/ic-temperatura-motor.svg';
import imgTemperatura from '../../../assets/img/alertas/ic-temperatura.svg';
import imgUnidadDesconectada from '../../../assets/img/alertas/ic-unidad-desconectada.svg';
import imgVelocidadRestablecida from '../../../assets/img/alertas/ic-velocidad-restablecida.svg';
import imgVolcado from '../../../assets/img/alertas/ic-volcado.svg';
import imgCamaraAI from '../../../assets/img/alertas/ic-grabando.svg';

import eventoMas30 from '../../../assets/img/marcadores/ic-+30.svg';
import eventoJammer from '../../../assets/img/marcadores/ic-Jammer.svg';
import eventoAceleracionBrusca from '../../../assets/img/marcadores/ic-aceleración-brusca.svg';
import eventoAddon from '../../../assets/img/marcadores/ic-addon-añadido.svg';
import eventoAlcoholimetroNoSuperaro from '../../../assets/img/marcadores/ic-alcoholimetro-no-superado.svg';
import eventoAproximacion from '../../../assets/img/marcadores/ic-alerta-aproximación.svg';
import eventoAproximacion1 from '../../../assets/img/marcadores/ic-alerta-aproximación_1.svg';
import eventoConexionTomaFuerza from '../../../assets/img/marcadores/ic-alerta-de-conexion-de-toma-de-fuerza.svg';
import eventoDesconexionTomaFuerza from '../../../assets/img/marcadores/ic-alerta-de-desconexion-de-toma-de-fuerza.svg';
import eventoApagadoMotorActivado from '../../../assets/img/marcadores/ic-apagado-motor-activado.svg';
import eventoApagadoMotorDesactivado from '../../../assets/img/marcadores/ic-apagado-motor-desactivado.svg';
import eventoCurvaBrusca from '../../../assets/img/marcadores/ic-curva-brusca.svg';
import eventoBloqueoPuerta from '../../../assets/img/marcadores/ic-bloqueo-de-puerta.svg';
import eventoBotonPanico from '../../../assets/img/marcadores/ic-botón-pánico.svg';
import eventoCheckEngine from '../../../assets/img/marcadores/ic-check-engine.svg';
import eventoColicionDerecha from '../../../assets/img/marcadores/ic-colición-derecha.svg';
import eventoColicionIzquierda from '../../../assets/img/marcadores/ic-colición-izquierda.svg';
import eventoColicionFrontera from '../../../assets/img/marcadores/ic-colición-frontera.svg';
import eventoColicionTrasera from '../../../assets/img/marcadores/ic-colición-trasera.svg';
import eventoDesbloqueoPuerta from '../../../assets/img/marcadores/ic-desbloqueo-de-puerta.svg';
import eventoDetenido from '../../../assets/img/marcadores/ic-detenido.svg';
import eventoDvrDesconectado from '../../../assets/img/marcadores/ic-dvr-desconectado.svg';
import eventoEncendidoSinPruebaAlcohol from '../../../assets/img/marcadores/ic-encendido-sin-prueba-de-alcohol.svg';
import eventoEntroCliente from '../../../assets/img/marcadores/ic-entro-cliente.svg';
import eventoEntroGeocerca from '../../../assets/img/marcadores/ic-entro-geocerca.svg';
import eventoEstacionCargaDentro from '../../../assets/img/marcadores/ic-estacion-carga-dentro.svg';
import eventoEstacionCargaFuera from '../../../assets/img/marcadores/ic-estacion-carga-fuera.svg';
import eventoExcesoVelocidad from '../../../assets/img/marcadores/ic-exceso-velocidad.svg';
import eventoFallaCorriente from '../../../assets/img/marcadores/ic-falla-corriente.svg';
import eventoFrenadoBrusco from '../../../assets/img/marcadores/ic-frenado-brusco.svg';
import eventoFuerzaOff from '../../../assets/img/marcadores/ic-fuerza-off.svg';
import eventoFuerzaOn from '../../../assets/img/marcadores/ic-fuerza-on.svg';
import eventoIcon1 from '../../../assets/img/marcadores/ic-icon1.svg';
import eventoIcon2 from '../../../assets/img/marcadores/ic-icon2.svg';
import eventoIcon3 from '../../../assets/img/marcadores/ic-icon3.svg';
import eventoMotorOff from '../../../assets/img/marcadores/ic-motor-off.svg';
import eventoMotorOn from '../../../assets/img/marcadores/ic-motor-on.svg';
import eventoOleajeCombustible from '../../../assets/img/marcadores/ic-oleaje-de-combustible.svg';
import eventoPerdidaSenial from '../../../assets/img/marcadores/ic-perdida-señal.svg';
import eventoPuertaAbierta from '../../../assets/img/marcadores/ic-puerta-abierta.svg';
import eventoPuertaCerrada from '../../../assets/img/marcadores/ic-puerta-cerrada.svg';
import eventoPuntoApagado from '../../../assets/img/marcadores/ic-punto-en-apagado.svg';
import eventoPuntoGps from '../../../assets/img/marcadores/ic-punto-en-gps.svg';
import eventoPuntoFinal from '../../../assets/img/marcadores/ic-punto-final.svg';
import eventoPuntoInicial from '../../../assets/img/marcadores/ic-punto-inicial.svg';
import eventoRangoHumedad from '../../../assets/img/marcadores/ic-rango-humedad.svg';
import eventoReferencia from '../../../assets/img/marcadores/ic-referencia.svg';
import eventoRoboCombustible from '../../../assets/img/marcadores/ic-robo-combustible.svg';
import eventoRpm from '../../../assets/img/marcadores/ic-rpm.svg';
import eventoSalioCliente from '../../../assets/img/marcadores/ic-salio-cliente.svg';
import eventoSalioGeocerca from '../../../assets/img/marcadores/ic-salio-geocerca.svg';
import eventoSeguroMagnetico from '../../../assets/img/marcadores/ic-seguro-magnetico.svg';
import eventoSensorCombustibleContaminado from '../../../assets/img/marcadores/ic-sensor-de-combustible-contaminado.svg';
import eventoSensorCombustibleDesconectado from '../../../assets/img/marcadores/ic-sensor-de-combustible-desconectado.svg';
import eventoSensorCombustibleReconectado from '../../../assets/img/marcadores/ic-sensor-de-combustible-reconectado.svg';
import eventoTemperaturaMotor from '../../../assets/img/marcadores/ic-temperatura-motor.svg';
import eventoTemperatura from '../../../assets/img/marcadores/ic-temperatura.svg';
import eventoUnidadDesconectada from '../../../assets/img/marcadores/ic-unidad-desconectada.svg';
import eventoVelocidadRestablecida from '../../../assets/img/marcadores/ic-velocidad-restablecida.svg';
import eventoVolcado from '../../../assets/img/marcadores/ic-volcado.svg';
import eventoMarcadorCliente from '../../../assets/img/marcadores/ic-marcador-cliente.svg';
import eventoMarcadorGeocerca from '../../../assets/img/marcadores/ic-marcador-geocerca.svg';
import eventoMarcadorReferencia from '../../../assets/img/marcadores/ic-marcador-referencia.svg';

import eventoCamaraIA from '../../../assets/img/marcadores/ic-grabando-2.svg'

import React from 'react';
import { ReactComponent as VehiculoCoche } from '../../../assets/img/vehiculos/coche_icon.svg';
import { ReactComponent as VehiculoGrua } from '../../../assets/img/vehiculos/grua_icon.svg';
import { ReactComponent as VehiculoMoto } from '../../../assets/img/vehiculos/moto_icon.svg';
import { ReactComponent as VehiculoPipa } from '../../../assets/img/vehiculos/pipa_icon.svg';
import { ReactComponent as VehiculoTruck } from '../../../assets/img/vehiculos/Truck.svg';
import { ReactComponent as VehiculoVan } from '../../../assets/img/vehiculos/van_icon.svg';

const tipo_MovimientoApagado = 0;

const tipo_Movimiento = 1;
const tipo_Apagado = 2;
const tipo_Apagado_de_Motor_Guardado = 3;
const tipo_Encendido_de_Motor_Guardado = 4;
const tipo_Apagado_de_Motor = 5;
const tipo_Encendido_de_Motor = 6;
const tipo_Errores_Motor = 7;
const tipo_OBD = 8;
const tipo_Peticion_de__Ubicacion = 9;
const tipo_Peticion_de_Ubicacion_Guardado = 10;
const tipo_Evento_Detenido = 11;
const tipo_Evento_Detenido_Guardado = 12;
const tipo_Exceso_de_Velocidad = 13;
const tipo_Exceso_de_Velocidad_Guardado = 14;
const tipo_Descenso_Velocidad = 15;
const tipo_Descenso_Velocidad_Guardado = 16;
const tipo_Alerta_Detenido = 17;
const tipo_Alerta_Detenido_Guardado = 18;
const tipo_Encendido_Motor_Fumigacion_Guardado = 19;
const tipo_Apagado_Motor_Fumigacion_Guardado = 20;
const tipo_Puerta_abierta = 21;
const tipo_Puerta_cerrada = 22;
const tipo_Puerta_Cerrada_Guardado = 23;
const tipo_Puerta_Abierta_Guardado = 24;
const tipo_Encendido_Motor_Fumigacion = 25;
const tipo_Apagado_Motor_Fumigacion = 26;
const tipo_Fumigacion_Encendido = 27;
const tipo_Fumigacion_Apagado = 28;
const tipo_Fumigacion_Encendido_Guardado = 29;
const tipo_Detenido = 30;
const tipo_Boton_Pánico = 31;
const tipo_Deshabilitar_ignicion = 32;
const tipo_Habilitar_ignicion = 33;
const tipo_Deshabilitar_ignicion_guardado = 34;
const tipo_Habilitar_ignicion_guardado = 35;
const tipo_Boton_Pánico_Guardado = 36;
const tipo_Fumigacion_Apagado_Guardado = 37;
const tipo_Puerta_2_Cerrada = 38;
const tipo_Puerta_2_Abierta = 39;
const tipo_Puerta_2_Cerrada_Guardado = 40;
const tipo_Puerta_2_Abierta_Guardado = 41;
const tipo_Puerta_3_Cerrada = 42;
const tipo_Puerta_3_Abierta = 43;
const tipo_Puerta_3_Cerrada_Guardado = 44;
const tipo_Puerta_3_Abierta_Guardado = 45;
const tipo_Puerta_4_Cerrada = 46;
const tipo_Puerta_4_Abierta = 47;
const tipo_Puerta_4_Cerrada_Guardado = 48;
const tipo_Puerta_4_Abierta_Guardado = 49;
const tipo_Puerta_5_Cerrada = 50;
const tipo_Puerta_5_Abierta = 51;
const tipo_Puerta_5_Cerrada_Guardado = 52;
const tipo_Puerta_5_Abierta_Guardado = 53;
const tipo_Puerta_6_Cerrada = 54;
const tipo_Puerta_6_Abierta = 55;
const tipo_Puerta_6_Cerrada_Guardado = 56;
const tipo_Puerta_6_Abierta_Guardado = 57;
const tipo_Alerta_Combustible = 58;
const tipo_Alerta_Combustible_Guardado = 59;
const tipo_Alerta_exceso_de_velocidad_en_curva = 60;
const tipo_Alerta_exceso_de_velocidad_en_curva_guardado = 61;
const tipo_Desconexion_de_Energía = 62;
const tipo_Acelerado_brusco = 64;
const tipo_Frenado_brusco = 65;
const tipo_Curva_brusca = 66;
const tipo_Acelerado_brusco_guardado = 67;
const tipo_Frenado_brusco_guardado = 68;
const tipo_Curva_brusca_guardado = 69;
const tipo_Alerta_Temperatura = 70;
const tipo_Alerta_Temperatura_G = 71;
const tipo_Alerta_Humedad = 72;
const tipo_Alerta_Humedad_G = 73;
const tipo_Alerta_Perdida_de_Senial = 74;
const tipo_Alerta_Perdida_de_Senial_G = 75;
const tipo_Alerta_Temperatura_de_Motor = 76;
const tipo_Alerta_Temperatura_de_Motor_G = 77;
const tipo_Alerta_de_exceso_de_revoluciones = 78;
const tipo_Alerta_de_exceso_de_revoluciones_G = 79;
const tipo_Alerta_de_Check_Engine = 80;
const tipo_Alerta_de_Check_Engine_G = 81;
const tipo_Alerta_de_Deteccion_de_Jammer = 82;
const tipo_Alerta_de_Deteccion_de_Jammer_G = 83;
const tipo_Prueba_de_alcoholímetro_no_superada = 84;
const tipo_Prueba_de_alcoholímetro_no_superada_G = 85;
const tipo_Alerta_Bloqueo_de_puerta = 86;
const tipo_Alerta_Bloqueo_de_puerta_G = 87;
const tipo_Alerta_Desbloqueo_de_puerta = 88;
const tipo_Alerta_Desbloqueo_de_puerta_G = 89;
const tipo_Oleaje_de_combustible = 98;
const tipo_Oleaje_de_combustible_G = 99;
const tipo_Bloqueo_Automatico_de_puerta = 100;
const tipo_Bloqueo_Automatico_de_puerta_G = 101;
const tipo_Sensor_de_combustible_Reconectado = 102;
const tipo_Sensor_de_combustible_Reconectado_G = 103;
const tipo_Lectura_Alcohol = 104;
const tipo_Lectura_Alcohol_G = 105;
const tipo_Alerta_de_Desconexion_de_Toma_de_Fuerza = 106;
const tipo_Alerta_de_Desconexion_de_Toma_de_Fuerza_G = 107;
const tipo_Sensor_de_combustible_contaminado = 108;
const tipo_Sensor_de_combustible_contaminado_G = 109;
const tipo_Alerta_de_Conexion_de_Toma_de_Fuerza = 110;
const tipo_Alerta_de_Conexion_de_Toma_de_Fuerza_G = 111;
const tipo_Alerta_de_vehiculo_volcado = 112;
const tipo_Alerta_de_vehiculo_volcado_G = 113;
const tipo_Alerta_de_colision_frontal = 114;
const tipo_Alerta_de_colision_frontal_G = 115;
const tipo_Alerta_de_colision_lateral_Izquierda = 116;
const tipo_Alerta_de_colision_lateral_Izquierda_G = 117;
const tipo_Alerta_de_colision_lateral_Derecha = 118;
const tipo_Alerta_de_colision_lateral_Derecha_G = 119;
const tipo_Alerta_de_colision_trasera = 120;
const tipo_Alerta_de_colision_trasera_G = 121
const marcadorCliente = 99990;
const marcadorGeocerca = 99991;
const marcadorReferencia = 99992;
const marcadorInicio = 99993;
const marcadorFin = 99994;
/*MARCADORES PARA RECORRIDO*/
export const obtenerIconoEvento = (tipo) => {
    var icono = "";
    const tipoInt = parseInt(tipo);
    switch (tipoInt) {
        case tipo_MovimientoApagado:
            icono = eventoPuntoApagado;
            break;
        case tipo_Movimiento:
            icono = eventoPuntoGps;
            break;
        case tipo_Apagado:
            icono = eventoMotorOff;
            break;
        case tipo_Apagado_de_Motor_Guardado:
            icono = eventoMotorOff;
            break;
        case tipo_Encendido_de_Motor_Guardado:
            icono = eventoMotorOn;
            break;
        case tipo_Apagado_de_Motor:
            icono = eventoMotorOff;
            break;
        case tipo_Encendido_de_Motor:
            icono = eventoMotorOn;
            break;
        case tipo_Errores_Motor:
            icono = eventoPuntoGps;
            break;
        case tipo_OBD:
            icono = eventoPuntoGps;
            break;
        case tipo_Peticion_de__Ubicacion:
            icono = eventoPuntoGps;
            break;
        case tipo_Peticion_de_Ubicacion_Guardado:
            icono = eventoPuntoGps;
            break;
        case tipo_Evento_Detenido:
            //icono = eventoDetenido;
            icono = eventoDetenido;
            break;
        case tipo_Evento_Detenido_Guardado:
            //icono = eventoDetenido;
            icono = eventoDetenido;
            break;
        case tipo_Exceso_de_Velocidad:
            icono = eventoExcesoVelocidad;
            break;
        case tipo_Exceso_de_Velocidad_Guardado:
            icono = eventoExcesoVelocidad;
            break;
        case tipo_Descenso_Velocidad:
            icono = eventoVelocidadRestablecida;
            break;
        case tipo_Descenso_Velocidad_Guardado:
            icono = eventoVelocidadRestablecida;
            break;
        case tipo_Alerta_Detenido:
            icono = eventoDetenido;

            break;
        case tipo_Alerta_Detenido_Guardado:
            //icono = eventoDetenido;
            icono = eventoDetenido;
            break;
        case tipo_Encendido_Motor_Fumigacion_Guardado:
            icono = eventoPuntoGps;
            break;
        case tipo_Apagado_Motor_Fumigacion_Guardado:
            icono = eventoPuntoGps;
            break;
        case tipo_Puerta_abierta:
            icono = eventoPuertaAbierta;
            break;
        case tipo_Puerta_cerrada:
            icono = eventoPuertaAbierta;
            break;
        case tipo_Puerta_Cerrada_Guardado:
            icono = eventoPuertaCerrada;
            break;
        case tipo_Puerta_Abierta_Guardado:
            icono = eventoPuertaAbierta;
            break;
        case tipo_Encendido_Motor_Fumigacion:
            icono = eventoPuntoGps;
            break;
        case tipo_Apagado_Motor_Fumigacion:
            icono = eventoPuntoGps;
            break;
        case tipo_Fumigacion_Encendido:
            icono = eventoPuntoGps;
            break;
        case tipo_Fumigacion_Apagado:
            icono = eventoPuntoGps;
            break;
        case tipo_Fumigacion_Encendido_Guardado:
            icono = eventoPuntoGps;
            break;
        case tipo_Detenido:
            icono = eventoDetenido;
            break;
        case tipo_Boton_Pánico:
            icono = eventoBotonPanico;
            break;
        case tipo_Deshabilitar_ignicion:
            icono = eventoApagadoMotorDesactivado;
            break;
        case tipo_Habilitar_ignicion:
            icono = eventoApagadoMotorActivado;
            break;
        case tipo_Deshabilitar_ignicion_guardado:
            icono = eventoApagadoMotorDesactivado;
            break;
        case tipo_Habilitar_ignicion_guardado:
            icono = eventoApagadoMotorActivado;
            break;
        case tipo_Boton_Pánico_Guardado:
            icono = eventoBotonPanico;
            break;
        case tipo_Fumigacion_Apagado_Guardado:
            icono = eventoPuntoGps;
            break;
        case tipo_Puerta_2_Cerrada:
            icono = eventoPuertaCerrada;
            break;
        case tipo_Puerta_2_Abierta:
            icono = eventoPuertaAbierta;
            break;
        case tipo_Puerta_2_Cerrada_Guardado:
            icono = eventoPuertaCerrada;
            break;
        case tipo_Puerta_2_Abierta_Guardado:
            icono = eventoPuertaAbierta;
            break;
        case tipo_Puerta_3_Cerrada:
            icono = eventoPuertaCerrada;
            break;
        case tipo_Puerta_3_Abierta:
            icono = eventoPuertaAbierta;
            break;
        case tipo_Puerta_3_Cerrada_Guardado:
            icono = eventoPuertaCerrada;
            break;
        case tipo_Puerta_3_Abierta_Guardado:
            icono = eventoPuertaAbierta;
            break;
        case tipo_Puerta_4_Cerrada:
            icono = eventoPuertaCerrada;
            break;
        case tipo_Puerta_4_Abierta:
            icono = eventoPuertaAbierta;
            break;
        case tipo_Puerta_4_Cerrada_Guardado:
            icono = eventoPuertaCerrada;
            break;
        case tipo_Puerta_4_Abierta_Guardado:
            icono = eventoPuertaAbierta;
            break;
        case tipo_Puerta_5_Cerrada:
            icono = eventoPuertaCerrada;
            break;
        case tipo_Puerta_5_Abierta:
            icono = eventoPuertaAbierta;
            break;
        case tipo_Puerta_5_Cerrada_Guardado:
            icono = eventoPuertaCerrada;
            break;
        case tipo_Puerta_5_Abierta_Guardado:
            icono = eventoPuertaAbierta;
            break;
        case tipo_Puerta_6_Cerrada:
            icono = eventoPuertaCerrada;
            break;
        case tipo_Puerta_6_Abierta:
            icono = eventoPuertaAbierta;
            break;
        case tipo_Puerta_6_Cerrada_Guardado:
            icono = eventoPuertaCerrada;
            break;
        case tipo_Puerta_6_Abierta_Guardado:
            icono = eventoPuertaAbierta;
            break;
        case tipo_Alerta_Combustible:
            icono = eventoRoboCombustible;
            break;
        case tipo_Alerta_Combustible_Guardado:
            icono = eventoRoboCombustible;
            break;
        case tipo_Alerta_exceso_de_velocidad_en_curva:
            icono = eventoCurvaBrusca;
            break;
        case tipo_Alerta_exceso_de_velocidad_en_curva_guardado:
            icono = eventoCurvaBrusca;
            break;
        case tipo_Desconexion_de_Energía:
            icono = eventoFallaCorriente;
            break;
        case tipo_Acelerado_brusco:
            icono = eventoAceleracionBrusca;
            break;
        case tipo_Frenado_brusco:
            icono = eventoFrenadoBrusco;
            break;
        case tipo_Curva_brusca:
            icono = eventoCurvaBrusca;
            break;
        case tipo_Acelerado_brusco_guardado:
            icono = eventoAceleracionBrusca;
            break;
        case tipo_Frenado_brusco_guardado:
            icono = eventoFrenadoBrusco;
            break;
        case tipo_Curva_brusca_guardado:
            icono = eventoCurvaBrusca;
            break;
        case tipo_Alerta_Temperatura:
            icono = eventoTemperatura;
            break;
        case tipo_Alerta_Temperatura_G:
            icono = eventoTemperatura;
            break;
        case tipo_Alerta_Humedad:
            icono = eventoRangoHumedad;
            break;
        case tipo_Alerta_Humedad_G:
            icono = eventoRangoHumedad;
            break;
        case tipo_Alerta_Perdida_de_Senial:
            icono = eventoPerdidaSenial;
            break;
        case tipo_Alerta_Perdida_de_Senial_G:
            icono = eventoPerdidaSenial;
            break;
        case tipo_Alerta_Temperatura_de_Motor:
            icono = eventoTemperaturaMotor;
            break;
        case tipo_Alerta_Temperatura_de_Motor_G:
            icono = eventoTemperaturaMotor;
            break;
        case tipo_Alerta_de_exceso_de_revoluciones:
            icono = eventoPuntoGps;
            break;
        case tipo_Alerta_de_exceso_de_revoluciones_G:
            icono = eventoPuntoGps;
            break;
        case tipo_Alerta_de_Check_Engine:
            icono = eventoCheckEngine;
            break;
        case tipo_Alerta_de_Check_Engine_G:
            icono = eventoCheckEngine;
            break;
        case tipo_Alerta_de_Deteccion_de_Jammer:
            icono = eventoJammer;
            break;
        case tipo_Alerta_de_Deteccion_de_Jammer_G:
            icono = eventoJammer;
            break;
        case tipo_Prueba_de_alcoholímetro_no_superada:
            icono = eventoAlcoholimetroNoSuperaro;
            break;
        case tipo_Prueba_de_alcoholímetro_no_superada_G:
            icono = eventoAlcoholimetroNoSuperaro;
            break;
        case tipo_Alerta_Bloqueo_de_puerta:
            icono = eventoBloqueoPuerta;
            break;
        case tipo_Alerta_Bloqueo_de_puerta_G:
            icono = eventoBloqueoPuerta;
            break;
        case tipo_Alerta_Desbloqueo_de_puerta:
            icono = eventoDesbloqueoPuerta;
            break;
        case tipo_Alerta_Desbloqueo_de_puerta_G:
            icono = eventoDesbloqueoPuerta;
            break;
        case tipo_Oleaje_de_combustible:
            icono = eventoOleajeCombustible;
            break;
        case tipo_Oleaje_de_combustible_G:
            icono = eventoOleajeCombustible;
            break;
        case tipo_Bloqueo_Automatico_de_puerta:
            icono = eventoPuntoGps;
            break;
        case tipo_Bloqueo_Automatico_de_puerta_G:
            icono = eventoPuntoGps;
            break;
        case tipo_Sensor_de_combustible_Reconectado:
            icono = eventoSensorCombustibleDesconectado;
            break;
        case tipo_Sensor_de_combustible_Reconectado_G:
            icono = eventoSensorCombustibleReconectado;
            break;
        case tipo_Lectura_Alcohol:
            icono = eventoPuntoGps;
            break;
        case tipo_Lectura_Alcohol_G:
            icono = eventoPuntoGps;
            break;
        case tipo_Alerta_de_Desconexion_de_Toma_de_Fuerza:
            icono = eventoIcon3;
            break;
        case tipo_Alerta_de_Desconexion_de_Toma_de_Fuerza_G:
            icono = eventoIcon3;
            break;
        case tipo_Sensor_de_combustible_contaminado:
            icono = eventoSensorCombustibleContaminado;
            break;
        case tipo_Sensor_de_combustible_contaminado_G:
            icono = eventoSensorCombustibleContaminado;
            break;
        case tipo_Alerta_de_Conexion_de_Toma_de_Fuerza:
            icono = eventoConexionTomaFuerza;
            break;
        case tipo_Alerta_de_Conexion_de_Toma_de_Fuerza_G:
            icono = eventoConexionTomaFuerza;
            break;
        case tipo_Alerta_de_vehiculo_volcado:
            icono = eventoVolcado;
            break;
        case tipo_Alerta_de_vehiculo_volcado_G:
            icono = eventoVolcado;
            break;
        case tipo_Alerta_de_colision_frontal:
            icono = eventoColicionFrontera;
            break;
        case tipo_Alerta_de_colision_frontal_G:
            icono = eventoColicionFrontera;
            break;
        case tipo_Alerta_de_colision_lateral_Izquierda:
            icono = eventoColicionIzquierda;
            break;
        case tipo_Alerta_de_colision_lateral_Izquierda_G:
            icono = eventoColicionIzquierda;
            break;
        case tipo_Alerta_de_colision_lateral_Derecha:
            icono = eventoColicionDerecha;
            break;
        case tipo_Alerta_de_colision_lateral_Derecha_G:
            icono = eventoColicionDerecha;
            break;
        case tipo_Alerta_de_colision_trasera:
            icono = eventoColicionTrasera;
            break;
        case tipo_Alerta_de_colision_trasera_G:
            icono = eventoColicionTrasera;
            break;
        case marcadorCliente:
            icono = eventoMarcadorCliente;
            break;
        case marcadorGeocerca:
            icono = eventoMarcadorGeocerca;
            break;
        case marcadorReferencia:
            icono = eventoMarcadorReferencia;
            break;
        case marcadorInicio:
            icono = eventoPuntoInicial;
            break;
        case marcadorFin:
            icono = eventoPuntoFinal;
            break;
    }
    if (icono)
        return <img src={icono} alt="Logo" style={{ maxHeight: '40px', maxWidth: '40ox' }} />;
    else return "";
};
/*MARCADORES PARA ALERTAS*/
export const obtenerIconoAlerta = (tipo) => {
    var icono = eventoPuntoGps;
    switch (parseInt(tipo)) {
        case Esta_con_el_cliente:
            icono = eventoEntroCliente;
            break;
        case Paso_por_la_referencia:
            icono = eventoReferencia;
            break;
        case Esta_en_la_Geocerca:
            icono = eventoEntroGeocerca;
            break;
        case Salio_de_la__Geocerca:
            icono = eventoSalioGeocerca;
            break;
        case Excedio_la_velocidad_a_KmsHr:
            icono = eventoExcesoVelocidad;
            break;
        case Esta_detenido:
            icono = eventoDetenido;
            break;
        case Salio_del_cliente:
            icono = eventoSalioCliente;
            break;
        case Robo_de_combustible_Litros:
            icono = eventoRoboCombustible;
            break;
        case Fuera_de_rango_de_temperatura_C:
            icono = eventoTemperatura;
            break;
        case Puerta_Abierta:
            icono = eventoPuertaAbierta;
            break;
        case Puerta_Cerrada:
            icono = eventoPuertaCerrada;
            break;
        case Corte_de_energia:
            icono = eventoFallaCorriente;
            break;
        case Boton_de_panico:
            icono = eventoBotonPanico;
            break;
        case El_vehiculo_Modero_la_velocidad_a_KmsHr:
            icono = eventoExcesoVelocidad;
            break;
        case Fin_de_viaje_con_el_cliente:
            icono = eventoPuntoFinal;
            break;
        case El_vehiculo_tiene_un_documento_vencido:
            icono = eventoPuntoGps;
            break;
        case Recuperacion_de_contraseña:
            icono = eventoPuntoGps;
            break;
        case Html_Pedidos:
            icono = eventoPuntoGps;
            break;
        case Puerta_Conductor_Abierta:
            icono = eventoPuertaAbierta;
            break;
        case Puerta_Conductor_Cerrada:
            icono = eventoPuertaCerrada;
            break;
        case Puerta_Copiloto_Abierta:
            icono = eventoPuertaAbierta;
            break;
        case Puerta_Copiloto_Cerrada:
            icono = eventoPuertaCerrada;
            break;
        case Compuerta_Combustible_Abierta:
            icono = eventoPuntoGps;
            break;
        case Compuerta_Combustible_Cerrada:
            icono = eventoPuntoGps;
            break;
        case Puerta_Carga_Abierta:
            icono = eventoPuntoGps;
            break;
        case Puerta_Carga_Cerrada:
            icono = eventoPuntoGps;
            break;
        case Puerta_Abierta_6:
            icono = eventoPuntoGps;
            break;
        case Puerta_Cerrada_6:
            icono = eventoPuntoGps;
            break;
        case Domo_1_Abierto:
            icono = eventoPuntoGps;
            break;
        case Domo_1_Cerrado:
            icono = eventoPuntoGps;
            break;
        case Domo_2_Abierto:
            icono = eventoPuntoGps;
            break;
        case Domo_2_Cerrado:
            icono = eventoPuntoGps;
            break;
        case Domo_3_Abierto:
            icono = eventoPuntoGps;
            break;
        case Domo_3_Cerrado:
            icono = eventoPuntoGps;
            break;
        case Domo_4_Abierto:
            icono = eventoPuntoGps;
            break;
        case Domo_4_Cerrado:
            icono = eventoPuntoGps;
            break;
        case Domo_5_Abierto:
            icono = eventoPuntoGps;
            break;
        case Domo_5_Cerrado:
            icono = eventoPuntoGps;
            break;
        case Domo_6_Abierto:
            icono = eventoPuntoGps;
            break;
        case Domo_6_Cerrado:
            icono = eventoPuntoGps;
            break;
        case Valvula_1_Abierto:
            icono = eventoPuntoGps;
            break;
        case Valvula_1_Cerrado:
            icono = eventoPuntoGps;
            break;
        case Valvula_2_Abierto:
            icono = eventoPuntoGps;
            break;
        case Valvula_2_Cerrado:
            icono = eventoPuntoGps;
            break;
        case Valvula_3_Abierto:
            icono = eventoPuntoGps;
            break;
        case Valvula_3_Cerrado:
            icono = eventoPuntoGps;
            break;
        case Valvula_4_Abierto:
            icono = eventoPuntoGps;
            break;
        case Valvula_4_Cerrado:
            icono = eventoPuntoGps;
            break;
        case Valvula_5_Abierto:
            icono = eventoPuntoGps;
            break;
        case Valvula_5_Cerrado:
            icono = eventoPuntoGps;
            break;
        case Valvula_6_Abierto:
            icono = eventoPuntoGps;
            break;
        case Valvula_6_Cerrado:
            icono = eventoPuntoGps;
            break;
        case Excedio_la_velocidad_en_curva_a_KmsHr:
            icono = eventoCurvaBrusca;
            break;
        case Encendido_de_Motor:
            icono = eventoMotorOn;
            break;
        case Apagado_de_Motor:
            icono = eventoMotorOff;
            break;
        case Robo_de_combustible_tanque_2_Litros:
            icono = eventoRoboCombustible;
            break;
        case _Sin_chofer:
            icono = eventoPuntoGps;
            break;
        case Sensor_Fuerza1_Abierto:
            icono = eventoFuerzaOn;
            break;
        case Sensor_Fuerza1_cerrado:
            icono = eventoFuerzaOff;
            break;
        case Sensor_Fuerza2_Abierto:
            icono = eventoFuerzaOn;
            break;
        case Sensor_Fuerza2_cerrado:
            icono = eventoFuerzaOff;
            break;
        case Sensor_Fuerza3_Abierto:
            icono = eventoFuerzaOn;
            break;
        case Sensor_Fuerza3_cerrado:
            icono = eventoFuerzaOff;
            break;
        case Sensor_Fuerza4_Abierto:
            icono = eventoFuerzaOn;
            break;
        case Sensor_Fuerza4_cerrado:
            icono = eventoFuerzaOff;
            break;
        case Sensor_Fuerza5_Abierto:
            icono = eventoFuerzaOn;
            break;
        case Sensor_Fuerza5_cerrado:
            icono = eventoFuerzaOff;
            break;
        case Sensor_Fuerza6_Abierto:
            icono = eventoFuerzaOn;
            break;
        case Sensor_Fuerza6_cerrado:
            icono = eventoFuerzaOff;
            break;
        case Detenido_Mas30:
            icono = eventoMas30;
            break;
        case Detenido_Apagado:
            icono = eventoDetenido;
            break;
        case Acercamiento:
            icono = eventoAproximacion;
            break;
        case Acelerado_brusco:
            icono = eventoAceleracionBrusca;
            break;
        case Frenado_brusco:
            icono = eventoFrenadoBrusco;
            break;
        case Curva_brusca:
            icono = eventoCurvaBrusca;
            break;
        case ProductosRuta:
            icono = eventoPuntoGps;
            break;
        case RutaNoEncontrado:
            icono = eventoPuntoGps;
            break;
        case RutaCancelada:
            icono = eventoPuntoGps;
            break;
        case RutaNoAceptada:
            icono = eventoPuntoGps;
            break;
        case Fuera_de_rango_de_Humedad:
            icono = eventoRangoHumedad;
            break;
        case Retraso_de_llegada_a_la_Geocerca:
            icono = eventoPuntoGps;
            break;
        case Retraso_de_llegada_a_la_Geocerca2:
            icono = eventoPuntoGps;
            break;
        case Perdida_de_señal:
            icono = imgPerdidaSenial;
            break;
        case Fuera_de_rango_de_temperatura_Motor_C:
            icono = eventoTemperaturaMotor;
            break;
        case Excedio_RPM_a_rpm:
            icono = eventoRpm;
            break;
        case Check_Engine_Encendido:
            icono = eventoCheckEngine;
            break;
        case Alerta_de_Detección_de_Jammer:
            icono = eventoJammer;
            break;
        case Prueba_Alcoholimetro_no_superada:
            icono = eventoAlcoholimetroNoSuperaro;
            break;
        case Addon_dañado:
            icono = eventoAddon;
            break;
        case Sensor_de_combustible_desconectado:
            icono = eventoSensorCombustibleDesconectado;
            break;
        case Unidad_desconectada:
            icono = eventoUnidadDesconectada;
            break;
        case Bateria_Baja:
            icono = eventoPuntoGps;
            break;
        case Bloqueo_Automático_de_Puerta:
            icono = eventoBloqueoPuerta;
            break;
        case Oleaje_de_combustible:
            icono = eventoOleajeCombustible;
            break;
        case Bloqueo_de_Puerta:
            icono = eventoBloqueoPuerta;
            break;
        case Desbloqueo_de_Puerta:
            icono = eventoDesbloqueoPuerta;
            break;
        case Sensor_de_Combustible_reconectado:
            icono = eventoSensorCombustibleReconectado;
            break;
        case ProductosRutav2:
            icono = eventoPuntoGps;
            break;
        case RutaCanceladav2:
            icono = eventoPuntoGps;
            break;
        case Htmlpedidosv2:
            icono = eventoPuntoGps;
            break;
        case DVR_apagado:
            icono = eventoDvrDesconectado;
            break;
        case Desconexión_de_Toma_de_Fuerza:
            icono = eventoDesconexionTomaFuerza;
            break;
        case Sensor_de_combustible_contaminado:
            icono = eventoSensorCombustibleContaminado;
            break;
        case Conexión_de_Toma_de_Fuerza:
            icono = eventoConexionTomaFuerza;
            break;
        case volcado:
            icono = eventoVolcado;
            break;
        case colisión_frontal:
            icono = eventoColicionFrontera;
            break;
        case colisión_lateral_izquiero:
            icono = eventoColicionIzquierda;
            break;
        case colisión_lateral_derecho:
            icono = eventoColicionDerecha;
            break;
        case colisión_trasero:
            icono = eventoColicionTrasera;
            break;
        case marcadorCliente:
            icono = eventoMarcadorCliente;
            break;
        case marcadorGeocerca:
            icono = eventoMarcadorGeocerca;
            break;
        case marcadorReferencia:
            icono = eventoMarcadorReferencia;
            break;
        case marcadorInicio:
            icono = eventoPuntoInicial;
            break;
        case marcadorFin:
            icono = eventoPuntoFinal;
            break;
    }
    if (icono)
        return <img src={icono} alt="Logo" style={{ maxHeight: '40px', maxWidth: '40ox' }} />;
    else return "";
};

export const obtenerIconoAlertaOmisiones = (tipo) => {
    var icono = eventoPuntoGps;
    debugger;
    switch (tipo) {
        case '6091ba1d662e2b2e74500a3d'://entrada geocerca
            icono = eventoEntroGeocerca;
            break;
        case '6091ba29662e2b2e74500a40'://salida geocerca
            icono = eventoSalioGeocerca;
            break;
        case '6091ba52662e2b2e74500a46'://exceso velocidad
            icono = eventoExcesoVelocidad;
            break;
        case '6091ba3e662e2b2e74500a43'://detenido
            icono = eventoDetenido;
            break;
        case '67cdff4ce6c16775470cf6dd'://desconexion de energia
            icono = eventoFallaCorriente;
            break;
        case '6761c644c3e4e161ae6ea34e'://boton de panico
            icono = eventoBotonPanico;
            break;
        case '6761c5eec3e4e161ae6ea34c'://motor encendido
            icono = eventoMotorOn;
            break;
        case '6761c5a6c3e4e161ae6ea34b'://motor apagado
            icono = eventoMotorOff;
            break;
        case '6189b3ea2a2e016f281d2a05'://Acercamiento
            icono = eventoAproximacion1;
            break;
        case '67cdffc5e6c16775470cf6de'://equipo fuera de linea
            icono = eventoPerdidaSenial;
            break;
        case marcadorCliente:
            icono = eventoMarcadorCliente;
            break;
        case marcadorGeocerca:
            icono = eventoMarcadorGeocerca;
            break;
        case marcadorReferencia:
            icono = eventoMarcadorReferencia;
            break;
    }
    if (icono)
        return <img src={icono} alt="Logo" style={{ maxHeight: '40px', maxWidth: '40ox' }} />;
    else return "";
};

export const obtenerIconoAlertaAI = (tipo) => {
    var icono = eventoCamaraIA;
    switch (tipo) {
        case marcadorCliente:
            icono = eventoMarcadorCliente;
            break;
        case marcadorGeocerca:
            icono = eventoMarcadorGeocerca;
            break;
        case marcadorReferencia:
            icono = eventoMarcadorReferencia;
            break;
    }
    return <img src={icono} alt="Logo" style={{ height: '20px', width: '20px' }} />;
};
const Esta_con_el_cliente = 1;
const Paso_por_la_referencia = 2;
const Esta_en_la_Geocerca = 3;
const Salio_de_la__Geocerca = 4;
const Excedio_la_velocidad_a_KmsHr = 5;
const Esta_detenido = 6;
const Salio_del_cliente = 7;
const Robo_de_combustible_Litros = 8;
const Fuera_de_rango_de_temperatura_C = 9;
const Puerta_Abierta = 10;
const Puerta_Cerrada = 11;
const Corte_de_energia = 12;
const Boton_de_panico = 13;
const El_vehiculo_Modero_la_velocidad_a_KmsHr = 14;
const Fin_de_viaje_con_el_cliente = 15;
const El_vehiculo_tiene_un_documento_vencido = 16;
const Recuperacion_de_contraseña = 17;
const Html_Pedidos = 18;
const Puerta_Conductor_Abierta = 19;
const Puerta_Conductor_Cerrada = 20;
const Puerta_Copiloto_Abierta = 21;
const Puerta_Copiloto_Cerrada = 22;
const Compuerta_Combustible_Abierta = 23;
const Compuerta_Combustible_Cerrada = 24;
const Puerta_Carga_Abierta = 25;
const Puerta_Carga_Cerrada = 26;
const Puerta_Abierta_6 = 27;
const Puerta_Cerrada_6 = 28;
const Domo_1_Abierto = 29;
const Domo_1_Cerrado = 30;
const Domo_2_Abierto = 31;
const Domo_2_Cerrado = 32;
const Domo_3_Abierto = 33;
const Domo_3_Cerrado = 34;
const Domo_4_Abierto = 35;
const Domo_4_Cerrado = 36;
const Domo_5_Abierto = 37;
const Domo_5_Cerrado = 38;
const Domo_6_Abierto = 39;
const Domo_6_Cerrado = 40;
const Valvula_1_Abierto = 41;
const Valvula_1_Cerrado = 42;
const Valvula_2_Abierto = 43;
const Valvula_2_Cerrado = 44;
const Valvula_3_Abierto = 45;
const Valvula_3_Cerrado = 46;
const Valvula_4_Abierto = 47;
const Valvula_4_Cerrado = 48;
const Valvula_5_Abierto = 49;
const Valvula_5_Cerrado = 50;
const Valvula_6_Abierto = 51;
const Valvula_6_Cerrado = 52;
const Excedio_la_velocidad_en_curva_a_KmsHr = 53;
const Encendido_de_Motor = 54;
const Apagado_de_Motor = 55;
const Robo_de_combustible_tanque_2_Litros = 56;
const _Sin_chofer = 57;
const Sensor_Fuerza1_Abierto = 58;
const Sensor_Fuerza1_cerrado = 59;
const Sensor_Fuerza2_Abierto = 60;
const Sensor_Fuerza2_cerrado = 61;
const Sensor_Fuerza3_Abierto = 62;
const Sensor_Fuerza3_cerrado = 63;
const Sensor_Fuerza4_Abierto = 64;
const Sensor_Fuerza4_cerrado = 65;
const Sensor_Fuerza5_Abierto = 66;
const Sensor_Fuerza5_cerrado = 67;
const Sensor_Fuerza6_Abierto = 68;
const Sensor_Fuerza6_cerrado = 69;
const Detenido_Mas30 = 101;
const Detenido_Apagado = 102;
const Acercamiento = 70;
const Acelerado_brusco = 71;
const Frenado_brusco = 72;
const Curva_brusca = 73;
const ProductosRuta = 75;
const RutaNoEncontrado = 15;
const RutaCancelada = 15;
const RutaNoAceptada = 15;
const Fuera_de_rango_de_Humedad = 74;
const Retraso_de_llegada_a_la_Geocerca = 103;
const Retraso_de_llegada_a_la_Geocerca2 = 104;
const Perdida_de_señal = 76;
const Fuera_de_rango_de_temperatura_Motor_C = 77;
const Excedio_RPM_a_rpm = 78;
const Check_Engine_Encendido = 79;
const Alerta_de_Detección_de_Jammer = 80;
const Prueba_Alcoholimetro_no_superada = 81;
const Addon_dañado = 82;
const Sensor_de_combustible_desconectado = 83;
const Unidad_desconectada = 105;
const Bateria_Baja = 106;
const Bloqueo_Automático_de_Puerta = 84;
const Oleaje_de_combustible = 85;
const Bloqueo_de_Puerta = 86;
const Desbloqueo_de_Puerta = 87;
const Sensor_de_Combustible_reconectado = 88;
const ProductosRutav2 = 75;
const RutaCanceladav2 = 15;
const Htmlpedidosv2 = 18;
const DVR_apagado = 89;
const Desconexión_de_Toma_de_Fuerza = 90;
const Sensor_de_combustible_contaminado = 91;
const Conexión_de_Toma_de_Fuerza = 92;
const volcado = 93;
const colisión_frontal = 94;
const colisión_lateral_izquiero = 95;
const colisión_lateral_derecho = 96;
const colisión_trasero = 97;

export const obtenerImgAlerta = (tipo) => {
    var icono = imgPuntoGps;
    switch (parseInt(tipo)) {
        case Esta_con_el_cliente:
            icono = imgEntroCliente;
            break;
        case Paso_por_la_referencia:
            icono = imgReferencia;
            break;
        case Esta_en_la_Geocerca:
            icono = imgEntroGeocerca;
            break;
        case Salio_de_la__Geocerca:
            icono = imgSalioGeocerca;
            break;
        case Excedio_la_velocidad_a_KmsHr:
            icono = imgExcesoVelocidad;
            break;
        case Esta_detenido:
            icono = imgDetenido;
            break;
        case Salio_del_cliente:
            icono = imgSalioCliente;
            break;
        case Robo_de_combustible_Litros:
            icono = imgRoboCombustible;
            break;
        case Fuera_de_rango_de_temperatura_C:
            icono = imgTemperatura;
            break;
        case Puerta_Abierta:
            icono = imgPuertaAbierta;
            break;
        case Puerta_Cerrada:
            icono = imgPuertaCerrada;
            break;
        case Corte_de_energia:
            icono = imgFallaCorriente;
            break;
        case Boton_de_panico:
            icono = imgBotonPanico;
            break;
        case El_vehiculo_Modero_la_velocidad_a_KmsHr:
            icono = imgExcesoVelocidad;
            break;
        case Fin_de_viaje_con_el_cliente:
            icono = imgPuntoFinal;
            break;
        case El_vehiculo_tiene_un_documento_vencido:
            icono = imgPuntoGps;
            break;
        case Recuperacion_de_contraseña:
            icono = imgPuntoGps;
            break;
        case Html_Pedidos:
            icono = imgPuntoGps;
            break;
        case Puerta_Conductor_Abierta:
            icono = imgPuertaAbierta;
            break;
        case Puerta_Conductor_Cerrada:
            icono = imgPuertaCerrada;
            break;
        case Puerta_Copiloto_Abierta:
            icono = imgPuertaAbierta;
            break;
        case Puerta_Copiloto_Cerrada:
            icono = imgPuertaCerrada;
            break;
        case Compuerta_Combustible_Abierta:
            icono = imgPuntoGps;
            break;
        case Compuerta_Combustible_Cerrada:
            icono = imgPuntoGps;
            break;
        case Puerta_Carga_Abierta:
            icono = imgPuntoGps;
            break;
        case Puerta_Carga_Cerrada:
            icono = imgPuntoGps;
            break;
        case Puerta_Abierta_6:
            icono = imgPuntoGps;
            break;
        case Puerta_Cerrada_6:
            icono = imgPuntoGps;
            break;
        case Domo_1_Abierto:
            icono = imgPuntoGps;
            break;
        case Domo_1_Cerrado:
            icono = imgPuntoGps;
            break;
        case Domo_2_Abierto:
            icono = imgPuntoGps;
            break;
        case Domo_2_Cerrado:
            icono = imgPuntoGps;
            break;
        case Domo_3_Abierto:
            icono = imgPuntoGps;
            break;
        case Domo_3_Cerrado:
            icono = imgPuntoGps;
            break;
        case Domo_4_Abierto:
            icono = imgPuntoGps;
            break;
        case Domo_4_Cerrado:
            icono = imgPuntoGps;
            break;
        case Domo_5_Abierto:
            icono = imgPuntoGps;
            break;
        case Domo_5_Cerrado:
            icono = imgPuntoGps;
            break;
        case Domo_6_Abierto:
            icono = imgPuntoGps;
            break;
        case Domo_6_Cerrado:
            icono = imgPuntoGps;
            break;
        case Valvula_1_Abierto:
            icono = imgPuntoGps;
            break;
        case Valvula_1_Cerrado:
            icono = imgPuntoGps;
            break;
        case Valvula_2_Abierto:
            icono = imgPuntoGps;
            break;
        case Valvula_2_Cerrado:
            icono = imgPuntoGps;
            break;
        case Valvula_3_Abierto:
            icono = imgPuntoGps;
            break;
        case Valvula_3_Cerrado:
            icono = imgPuntoGps;
            break;
        case Valvula_4_Abierto:
            icono = imgPuntoGps;
            break;
        case Valvula_4_Cerrado:
            icono = imgPuntoGps;
            break;
        case Valvula_5_Abierto:
            icono = imgPuntoGps;
            break;
        case Valvula_5_Cerrado:
            icono = imgPuntoGps;
            break;
        case Valvula_6_Abierto:
            icono = imgPuntoGps;
            break;
        case Valvula_6_Cerrado:
            icono = imgPuntoGps;
            break;
        case Excedio_la_velocidad_en_curva_a_KmsHr:
            icono = imgExcesoVelocidad;
            break;
        case Encendido_de_Motor:
            icono = imgMotorOn;
            break;
        case Apagado_de_Motor:
            icono = imgMotorOff;
            break;
        case Robo_de_combustible_tanque_2_Litros:
            icono = imgRoboCombustible;
            break;
        case _Sin_chofer:
            icono = imgPuntoGps;
            break;
        case Sensor_Fuerza1_Abierto:
            icono = imgFuerzaOn;
            break;
        case Sensor_Fuerza1_cerrado:
            icono = imgFuerzaOff;
            break;
        case Sensor_Fuerza2_Abierto:
            icono = imgFuerzaOn;
            break;
        case Sensor_Fuerza2_cerrado:
            icono = imgFuerzaOff;
            break;
        case Sensor_Fuerza3_Abierto:
            icono = imgFuerzaOn;
            break;
        case Sensor_Fuerza3_cerrado:
            icono = imgFuerzaOff;
            break;
        case Sensor_Fuerza4_Abierto:
            icono = imgFuerzaOn;
            break;
        case Sensor_Fuerza4_cerrado:
            icono = imgFuerzaOff;
            break;
        case Sensor_Fuerza5_Abierto:
            icono = imgFuerzaOn;
            break;
        case Sensor_Fuerza5_cerrado:
            icono = imgFuerzaOff;
            break;
        case Sensor_Fuerza6_Abierto:
            icono = imgFuerzaOff;
            break;
        case Sensor_Fuerza6_cerrado:
            icono = imgFuerzaOff;
            break;
        case Detenido_Mas30:
            icono = imgMas30;
            break;
        case Detenido_Apagado:
            icono = imgPuntoApagado;
            break;
        case Acercamiento:
            icono = imgAproximacion;
            break;
        case Acelerado_brusco:
            icono = imgAceleracionBrusca;
            break;
        case Frenado_brusco:
            icono = imgFrenadoBrusco;
            break;
        case Curva_brusca:
            icono = imgPuntoGps;
            break;
        case ProductosRuta:
            icono = imgPuntoGps;
            break;
        case RutaNoEncontrado:
            icono = imgPuntoGps;
            break;
        case RutaCancelada:
            icono = imgPuntoGps;
            break;
        case RutaNoAceptada:
            icono = imgPuntoGps;
            break;
        case Fuera_de_rango_de_Humedad:
            icono = imgRangoHumedad;
            break;
        case Retraso_de_llegada_a_la_Geocerca:
            icono = imgPuntoGps;
            break;
        case Retraso_de_llegada_a_la_Geocerca2:
            icono = imgPuntoGps;
            break;
        case Perdida_de_señal:
            icono = imgPerdidaSenial;
            break;
        case Fuera_de_rango_de_temperatura_Motor_C:
            icono = imgTemperaturaMotor;
            break;
        case Excedio_RPM_a_rpm:
            icono = imgRpm;
            break;
        case Check_Engine_Encendido:
            icono = imgCheckEngine;
            break;
        case Alerta_de_Detección_de_Jammer:
            icono = imgJammer;
            break;
        case Prueba_Alcoholimetro_no_superada:
            icono = imgAlcoholimetroNoSuperaro;
            break;
        case Addon_dañado:
            icono = imgAddon;
            break;
        case Sensor_de_combustible_desconectado:
            icono = imgSensorCombustibleDesconectado;
            break;
        case Unidad_desconectada:
            icono = imgUnidadDesconectada;
            break;
        case Bateria_Baja:
            icono = imgBateriaBaja;
            break;
        case Bloqueo_Automático_de_Puerta:
            icono = imgBloqueoPuerta;
            break;
        case Oleaje_de_combustible:
            icono = imgOleajeCombustible;
            break;
        case Bloqueo_de_Puerta:
            icono = imgBloqueoPuerta;
            break;
        case Desbloqueo_de_Puerta:
            icono = imgDesbloqueoPuerta;
            break;
        case Sensor_de_Combustible_reconectado:
            icono = imgSensorCombustibleReconectado;
            break;
        case ProductosRutav2:
            icono = imgPuntoGps;
            break;
        case RutaCanceladav2:
            icono = imgPuntoGps;
            break;
        case Htmlpedidosv2:
            icono = imgPuntoGps;
            break;
        case DVR_apagado:
            icono = imgDvrDesconectado;
            break;
        case Desconexión_de_Toma_de_Fuerza:
            icono = imgDesconexionTomaFuerza;
            break;
        case Sensor_de_combustible_contaminado:
            icono = imgSensorCombustibleContaminado;
            break;
        case Conexión_de_Toma_de_Fuerza:
            icono = imgConexionTomaFuerza;
            break;
        case volcado:
            icono = imgVolcado;
            break;
        case colisión_frontal:
            icono = imgColicionFrontera;
            break;
        case colisión_lateral_izquiero:
            icono = imgColicionIzquierda;
            break;
        case colisión_lateral_derecho:
            icono = imgColicionDerecha;
            break;
        case colisión_trasero:
            icono = imgColicionTrasera;
            break;
    }
    return <img src={icono} alt="Logo" style={{ height: '20px', width: '20px' }} />;
};
export const obtenerImgAlertaOmisiones = (tipo) => {
    var icono = imgPuntoGps;
    switch (tipo) {
        case '6091ba1d662e2b2e74500a3d'://entrada geocerca
            icono = imgEntroGeocerca;
            break;
        case '6091ba29662e2b2e74500a40'://salida geocerca
            icono = imgSalioGeocerca;
            break;
        case '6091ba52662e2b2e74500a46'://exceso velocidad
            icono = imgExcesoVelocidad;
            break;
        case '6091ba3e662e2b2e74500a43'://detenido
            icono = imgDetenido;
            break;
        case '67cdff4ce6c16775470cf6dd'://desconexion de energia
            icono = imgFallaCorriente;
            break;
        case '6761c644c3e4e161ae6ea34e'://boton de panico
            icono = imgBotonPanico;
            break;
        case '6761c5eec3e4e161ae6ea34c'://motor encendido
            icono = imgMotorOn;
            break;
        case '6761c5a6c3e4e161ae6ea34b'://motor apagado
            icono = imgMotorOff;
            break;
        case '6189b3ea2a2e016f281d2a05'://Acercamiento
            icono = imgAproximacion1;
            break;
        case '67cdffc5e6c16775470cf6de'://equipo fuera de linea
            icono = imgPerdidaSenial;
            break;
    }
    return <img src={icono} alt="Logo" style={{ height: '20px', width: '20px' }} />;
};
export const obtenerImgAlertaCamara = (tipo) => {
    var icono = imgCamaraAI;
    return <img src={icono} alt="Logo" style={{ height: '20px', width: '20px' }} />;
};
export const obtenerIconoVehiculo = (tipo, color) => {
    let c = (color ?? 'black').toLocaleLowerCase().replace('white', '#e8e8e8');
    c = c.replace('#ffffff', '#e8e8e8');

    var icono = <VehiculoCoche src={icono} fill={c} style={{ height: '20px', width: '20px' }} />;
    let t = `${tipo}`.toLocaleLowerCase();
    if (t.includes('grua')) {
        icono = <VehiculoGrua src={icono} fill={c} style={{ height: '20px', width: '20px' }} />;
    }
    if (t.includes('moto')) {
        icono = <VehiculoMoto src={icono} fill={c} style={{ height: '20px', width: '20px' }} />;
    }
    if (t.includes('pipa')) {
        icono = <VehiculoPipa src={icono} fill={c} style={{ height: '20px', width: '20px' }} />;
    }
    if (t.includes('truck')) {
        icono = <VehiculoTruck src={icono} fill={c} style={{ height: '20px', width: '20px' }} />;
    }
    if (t.includes('van')) {
        icono = <VehiculoVan src={icono} fill={c} style={{ height: '20px', width: '20px' }} />;
    }
    return icono;
}

export const obtenerIconoTipoEstadia = (tipo) => {

    let icono = imgPuntoGps;

    switch (tipo) {

        case 'clientes':
            icono = eventoMarcadorCliente;
            break;
        case 'referencias':
            icono = eventoMarcadorReferencia;
            break;
        case 'geocercas':
            icono = eventoMarcadorGeocerca;
            break;

        default:
            icono = null;
            break;
    }

    //si el icono es invalido devuelve un fragmento vacio
    if (icono == null) {
        return <></>;
    }

    //Devuelve el tag html para mostrar icono en la vista 
    return <img src={icono} alt="Logo" style={{ height: '20px', width: '20px' }} />;
}